<script>
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

export default {
  name: "DocumentTrackModal",
  components: {
    DatePicker,
    Multiselect
  },
  data() {
    return {
      submitted: false,
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "title",
          sortable: true,
          label: "Tracks"
        },
        {
          key: "processType",
          sortable: true,
          label: "Process Type",
          thStyle: { width: "150px" }
        },
        {
          key: "deliveryUnit",
          sortable: true,
          label: "Created By",
          thStyle: { width: "150px" }
        },
        {
          key: "actionDateTime",
          sortable: true,
          label: "Processed On",
          thStyle: { width: "150px" }
        }
      ],
      processedDateRange: "",
      dateRangeIndex: 0,
      indexSelected: -1,
      tableBusy: false,
      toggleAll: false,
      filterTrack: [],
      processType: null,
      processTypeOptions: [],
      selectedDU: null,
      selectedDepartment: null,
      selectedCampus: this.$store.state.data.selectedCampus.id
    };
  },
  computed: {
    selectedTrack() {
      return this.tableData.filter((row) => row.toggleTrack);
    },
    filtered() {
      let data = this.tableData;
      if (this.processType) {
        data = data.filter((item) => {
          if (item.processTypeId) {
            if (item.processTypeId == this.processType.id)
              return item.processTypeId == this.processType.id;
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter) {
        return this.totalRows;
      }
      return this.filtered.length;
    }
  },
  methods: {
    setData(data, selectedDU, selectedDepartment) {
      this.selectedDU = selectedDU;
      this.selectedDepartment = selectedDepartment;
      this.filterTrack = data;
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = null;
      this.tableBusy = true;
      this.toggleAll = false;
      this.processType = null;
      this.processTypeOptions = [];
      this.getProcessType();
      this.getTracks();
    },
    getTracks() {
      if (
        this.processedDateRange == "" ||
        this.processedDateRange[0] == null ||
        this.processedDateRange[1] == null
      )
        this.setDateRange();
      this.$store
        .dispatch("dtstrack/GetProcessedTrack", {
          deliveryUnitId: this.selectedDU,
          departmentId: this.selectedDepartment,
          dateFrom: this.processedDateRange[0],
          dateTo: this.processedDateRange[1]
        })
        .then((res) => {
          res.data.forEach((item) => {
            item.toggleTrack = false;
          });
          this.tableBusy = false;
          this.tableData = res.data.filter((item) => {
            var count = 0;
            for (
              var counter = 0;
              counter < this.filterTrack.length;
              counter++
            ) {
              if (this.filterTrack[counter].id == item.id) count++;
            }
            return count == 0;
          });
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong!", "error");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleAllItems() {
      this.tableData.forEach((item) => {
        item.toggleTrack = this.toggleAll === true ? true : false;
      });
    },
    checkToggle() {
      var count = 0;
      this.tableData.forEach((item) => {
        if (item.toggleTrack) count++;
      });
      if (count === this.tableData.length) {
        this.toggleAll = true;
      } else {
        this.toggleAll = false;
      }
    },
    setDateRange() {
      this.processedDateRange = [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      ];
      this.dateRangeIndex = 3;
    },
    selectDate(type) {
      if (type == "Today") {
        this.dateRangeIndex = 0;
        this.$refs.processedDateRange.currentValue = [new Date(), new Date()];
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Yesterday") {
        this.$refs.processedDateRange.currentValue = [
          new Date(Date.now() - 3600 * 1000 * 24),
          new Date(Date.now() - 3600 * 1000 * 24)
        ];
        this.dateRangeIndex = 1;
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Last 7 Days") {
        this.$refs.processedDateRange.currentValue = [
          new Date(Date.now() - 7 * 24 * 3600 * 1000),
          new Date()
        ];
        this.dateRangeIndex = 2;
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "This Month") {
        this.$refs.processedDateRange.currentValue = [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
        ];
        this.dateRangeIndex = 3;
        if (this.$refs.processedDateRange)
          this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Last Month") {
        this.$refs.processedDateRange.currentValue = [
          new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
          new Date(new Date().getFullYear(), new Date().getMonth(), 0)
        ];
        this.dateRangeIndex = 4;
        this.$refs.processedDateRange.handleConfirmDate();
      } else if (type == "Custom") {
        this.dateRangeIndex = 5;
      }
    },
    getProcessType() {
      this.$store.dispatch("dtsprocesstype/GetProcessType").then((res) => {
        this.processTypeOptions = res.data.sort(function(a, b) {
          if (a.processName < b.processName) {
            return -1;
          }
          if (a.processName > b.processName) {
            return 1;
          }
          return 0;
        });
      });
    },
    processTypeLabel({ processName }) {
      return `${processName}`;
    },
    dropData(data) {
      if (data.length > 0) {
        data[0].toggleTrack = !data[0].toggleTrack;
        this.$forceUpdate();
      }
    },
    proceedChecking(selected) {
      this.$emit("dropMultiple", selected);
      this.$bvModal.hide("tracks-modal");
    }
  }
};
</script>

<template>
  <b-modal
    id="tracks-modal"
    title="Link Tracks"
    size="xl"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <div class="row">
      <div class="col-md-3">
        <div class="mb-2">
          <div class="mb-1">Date Range:</div>
          <date-picker
            ref="processedDateRange"
            v-model="processedDateRange"
            :first-day-of-week="1"
            lang="en"
            range
            placeholder="Enter Date Range..."
            @change="getTracks"
          >
            <div
              v-if="processedDateRange != ''"
              slot="input"
              class="form-control"
            >
              <div
                v-if="
                  formatDateShort(new Date(processedDateRange[0])) !=
                    formatDateShort(new Date(processedDateRange[1]))
                "
              >
                {{ formatDateShort(new Date(processedDateRange[0])) }} -
                {{ formatDateShort(new Date(processedDateRange[1])) }}
              </div>
              <div v-else>
                {{ formatDate(new Date(processedDateRange[0])) }}
              </div>
            </div>
            <template v-slot:sidebar>
              <div
                @click="selectDate('Today')"
                class="py-1 px-2 cursor-pointer"
                :class="{
                  'date-range-selected': dateRangeIndex == 0
                }"
              >
                Today
              </div>
              <div
                @click="selectDate('Yesterday')"
                class="py-1 px-2 cursor-pointer"
                :class="{
                  'date-range-selected': dateRangeIndex == 1
                }"
              >
                Yesterday
              </div>
              <div
                @click="selectDate('Last 7 Days')"
                class="py-1 px-2 cursor-pointer"
                :class="{
                  'date-range-selected': dateRangeIndex == 2
                }"
              >
                Last 7 Days
              </div>
              <div
                @click="selectDate('This Month')"
                class="py-1 px-2 cursor-pointer"
                :class="{
                  'date-range-selected': dateRangeIndex == 3
                }"
              >
                This Month
              </div>
              <div
                @click="selectDate('Last Month')"
                class="py-1 px-2 cursor-pointer"
                :class="{
                  'date-range-selected': dateRangeIndex == 4
                }"
              >
                Last Month
              </div>
              <div
                @click="selectDate('Custom')"
                class="py-1 px-2 cursor-pointer"
                :class="{
                  'date-range-selected': dateRangeIndex == 5
                }"
              >
                Custom
              </div>
            </template>
            <template v-if="dateRangeIndex != 5" v-slot:content>
              {{ null }}
            </template>
          </date-picker>
        </div>
        <div class="mb-2">
          <div class="mb-1">Process Type:</div>
          <multiselect
            v-model="processType"
            track-by="processName"
            label="processName"
            placeholder="Select Process..."
            :custom-label="processTypeLabel"
            :show-labels="false"
            :options="processTypeOptions"
            :searchable="true"
            :multiple="false"
            :allow-empty="false"
            :close-on-select="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="col-md-9">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <h5>Processed Tracks</h5>
          <div style="width: 250px">
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control"
            ></b-form-input>
          </div>
        </div>
        <div class="table-responsive mb-0">
          <b-table
            class="datatables"
            :items="filtered"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="tableBusy"
            @filtered="onFiltered"
            bordered
            outlined
            hover
            striped
            show-empty
            select-mode="range"
            selectable
            @row-selected="dropData"
          >
            <template #empty="scope">
              <div class="text-center">{{ scope.emptyText }}</div>
            </template>
            <template #table-busy>
              <div class="d-flex justify-content-center align-items-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #head(title)>
              <div
                v-if="!tableBusy && tableData.length > 0"
                class="form-check form-checkbox-outline form-check-success mb-0"
              >
                <input
                  type="checkbox"
                  id="toggleAll"
                  checked="checked"
                  class="form-check-input"
                  @change="toggleAllItems()"
                  v-model="toggleAll"
                /><label for="toggleAll" class="form-check-label">
                  <div>Name</div>
                </label>
              </div>
            </template>
            <template #cell(title)="row">
              <div
                class="form-check form-checkbox-outline form-check-success mb-0"
              >
                <input
                  type="checkbox"
                  :id="`toggleTrack-${row.item.id}`"
                  checked="checked"
                  class="form-check-input"
                  @change="checkToggle()"
                  v-model="row.item.toggleTrack"
                /><label
                  :for="`toggleTrack-${row.item.id}`"
                  class="form-check-label"
                >
                  <div>{{ row.item.referenceNumber }}</div>
                  <b>
                    {{ row.item.title }}
                  </b>
                </label>
              </div>
            </template>
            <template #cell(processType)="row">
              <div>
                {{ row.item.processType.processName }}
              </div>
              <small>
                {{ row.item.processType.easeOfDoingBusinessType }}
              </small>
            </template>
            <template #cell(deliveryUnit)="row">
              {{ row.item.deliveryUnit.name }}
            </template>
            <template #cell(actionDateTime)="row">
              {{ formatDateWithTime(new Date(row.item.actionDateTime)) }}
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed fix-top-middle" v-if="selectedTrack.length > 0">
      <button
        type="button"
        class="btn btn-success text-truncate"
        @click="proceedChecking(selectedTrack)"
      >
        Proceed with {{ selectedTrack.length }} selected Tracks
      </button>
    </div>
  </b-modal>
</template>
